import { type FC } from "react";

/**
 * RealEstateApp - landing page for the Real Estate workspace
 *
 * @returns RealEstateApp component
 *
 */
export const RealEstateApp: FC = () => {
  return <div className="p-4">Real Estate Workspace</div>;
};
